import { CAlert, CButton, CInput, CInputCheckbox, CModal, CModalBody, CModalFooter } from '@coreui/react';
import moment from 'moment';
import * as React from 'react';
import { Table } from 'reactstrap';
import { ControlTypeEnum, IBarCodeReceived, IDispatcher, IMessageBox, IPlay, IRegExpResultModel, IServiceMessage, IVirtualKeyboard } from '../abstraction';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';
import { ColumnModel, TableModel } from '../models/index';
import { InternalTypeEnum } from '../models/InternalTypeEnum';
import { KInput } from './Controls';
import { IProgressParams, KProgress } from './KProgress';

interface IProps {
	isOpen: boolean;
	closeCallBack: (submit: boolean, newRows: any[]) => any;
	table: TableModel;
	msgboxProvider: IMessageBox;
	virtualKeyboardProvider: IVirtualKeyboard;
	dispatcher: IDispatcher;
	barCodeSvc: IBarCodeReceived;
	soundSvc: IPlay;
}

interface IState {
	colDefs: ColumnModel[],			// Copie du modèle des colonnes du tableau
	rows: any[];					// Contient les données du tableau (y compris nouvelle ligne)
	sortCol: string;				// Indique le nom de la colonne utilisée pour trier
	ascending: number;				// Sens du tri
	selectedIndex: string;			// Index de la ligne sélectionnée
	virtualKeyboard: boolean;		// Clavier virtuel activé ou non
	isValid: boolean;				// Etat du bouton Valider. Dépend de l'eval de l'attribut tableau VALIDCOND
}

// Affiche en plein écran un tableau avec une saisie via lecture code barre 
// 
export class KMultiScan extends React.Component<IProps, IState> {
	private sortFlag: boolean = true;

	public constructor(props: any) {
		super(props);

		let sort = this.props.table.DefaultSort;
		let ascending = 1;
		if (sort) {
			if (sort.startsWith('-')) {
				ascending = -1;
				sort = sort.substring(1);
			}
		}
		else {
			sort = this.props.table.colsDef[0].Key;
		}

		let rows: any[] = [];

		if (this.props.table.newRows) {
			let csvRows = this.props.table.newRows.split("\n");

			csvRows.filter(r => r != "").map((r, iRow) => {
				let csvCols = r.split(';');

				let row: any[] = [];
				row["_ID_"] = iRow;

				this.props.table.colsDef.map((col, iCol) => {
					row[col.Key] = csvCols[iCol];
				});
				rows.push(row);
			});
		}

		this.state = {
			colDefs: this.props.table.colsDef.slice(0),
			rows: rows,
			sortCol: sort,
			ascending: ascending,
			selectedIndex: "",
			isValid: true,
			virtualKeyboard: this.props.virtualKeyboardProvider.isVirtualKeyboardActive,
		}

		this.state.colDefs.map(c => c.Disable = false);

		this.props.barCodeSvc.OnBarCodeReceived.add((data) => {
			this.onBarCodeReceived(data);
			return true;
		});
	}

	//#region Hacks React

	// Pour éviter un warning sur la console JS du navigateur, on se désabonne de l'évènement
	componentWillUnmount = () => {
		this.props.barCodeSvc.OnBarCodeReceived.EventHandlers.splice(1);
	}

	//#endregion

	//#region Local events

	// Lecture d'un code barre
	//
	onBarCodeReceived = (cb: string) => {
		var erExpr = this.props.table.NormBarcod;

		this.props.dispatcher.regParser(erExpr, cb)
			.then((result: IRegExpResultModel) => {
				let match = false;

				// Ne pas supprimer => Formules X3				\/
				let row = [];									// Ligne courante
				let ctx = this.props.dispatcher.getLastViewContext();		// Contexte de la page
				let table = this.props.table;					// Tableau destination
				let fields: any[] = [];							// Champs de la page
				let somme: number[] = [];						// Somme de chaque colonne des ajouts
				let rows = this.state.rows;						// Nouvelles lignes
				let groups: string[] = [];						// Nom/valeurs des groupes scannés
				// Ne pas supprimer => Formules X3				/\

				let colDefs = this.state.colDefs;

				// On recopie les valeurs pour les mettre à disposition de X3 dans les formules
				ctx.Controls.map(c => fields[c.Code] = c.Value);
				result.groups.map(g => {
					groups[g.groupName] = g.value
				});

				for (let cntCol = 0; cntCol < this.state.colDefs.length; cntCol++) {
					let col = colDefs[cntCol];
					let group = result.groups.filter(g => g.groupName == col.ColBarCodeName)[0];

					if (group) {
						match = true;

						let value: string = group.value;

						// Ne PAS supprimer isUnique => Utilisé dans les formules X3
						let isUnique = !(rows.filter(x => x[col.FieldName] == value)[0] != undefined);

						if (col.ColCbUnique && !isUnique) {
							this.props.soundSvc.playError();
							this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.nonUniqueInput, 3);
							return;
						}

						if (col.ColBarCodeValidCond) {
							try {
								// On évalue la condition définie depuis X3 pour cette colonne
								if (!eval(col.ColBarCodeValidCond)) {
									this.props.soundSvc.playError();
									this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.codBarValidError.replace('%%0%%', col.FieldName), 3);
									return;
								}
							}
							catch (err) {
								this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.codBarValidParseError.replace('%%0%%', col.FieldName), 3);
								return;
							}
						}

						row[col.FieldName] = value;

						if (Number(value) != undefined) {
							somme[col.FieldName] = Number(value);
							rows.map(r => { somme[col.FieldName] += Number(r[col.FieldName]) });
						}

					}
				}

				// Le code barre a été intreprété et certaines valeurs ont été mappées sur les colonnes
				// La ligne est donc OK et devrait être insérée, sauf si des controles l'interdisent
				if (match) {

					// Une formule conditionnel existe t elle 
					if (this.props.table.BarCodCond) {
						// On évalue la formule => false = formule non respectée, erreur de saisie
						try {
							if (!eval(this.props.table.BarCodCond)) {
								this.props.soundSvc.playError();
								this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.codBarValidError, 3);
								return;
							}
						}
						catch (err) {
							// Impossible d'interpréter la formule => erreur de syntaxe javascript
							this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.codBarValidParseError.replace('%%0%%', this.props.table.Key), 3);
							return;
						}
					}

					row["_ID_"] = rows.length + 1;
					row["_TS_"] = result.timestamp;

					rows.push(row);
					this.props.soundSvc.playOk();

					if (table.ValidCond) {
						try {
							this.setState({ isValid: eval(table.ValidCond) });
						}
						catch (err) {
							this.props.soundSvc.playError();
							this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, AppLabels.validCondAttrParseError, 3);
							this.setState({ isValid: false });
						}
					}
				}

				this.setState({ rows: rows }); //.forceUpdate();
			})
			.catch((err: IServiceMessage[]) => {
				this.props.msgboxProvider.MessageBox(AppLabels.errorTitle, err[0].message, err[0].level);
			});
	}

	// Clic sur le bouton Valider ou Cancel
	//
	onCloseClick = (submit: boolean): void => {
		if (this.props.closeCallBack) this.props.closeCallBack(submit, submit ? this.state.rows : []);
	}

	// Clic sur entete de colonne
	//
	onHeaderClick = (x: ColumnModel) => {
		// Ordre de tri en cours
		let order = this.state.ascending;

		// Si colonne cliquée identique au tri en cours, on inverse simplement l'ordre de tri
		if (x.Key == this.state.sortCol) {
			order = -order;
			this.setState({ ascending: order });
		}

		this.sortFlag = true;
		this.sort(x.Key, order);

		this.setState({ sortCol: x.Key })
	}

	// Suppression d'une ligne précédemment insérée 
	//
	onRemoveRowClick = (row, rowIndex) => {
		let rows = this.state.rows.filter(r => r["_ID_"] != row["_ID_"])
		this.setState({ rows: rows });
	}

	// Sélection d'une ligne du tableau
	// 
	onRowSelected = async (row: any, index: number) => {
		// On a recliqué sur la même ligne (selectedIndex=ligne en cours) => sans effet
		if (row["_ID_"] == this.state.selectedIndex) return;

		this.setState({ selectedIndex: row["_ID_"] })
	}

	// 
	// 
	onInputChange = (value: string, row: any, code: string) => {
		// Mise à jour du champ de la ligne sélectionnée 

		let editedRow = this.state.rows.filter(r => r["_ID_"] == this.state.selectedIndex)[0];
		if (editedRow) {
			editedRow[code] = value;

			this.state.colDefs.filter(c => c.Key == code)[0].Value = value;
		}
		this.forceUpdate();
	}

	//#endregion

	//#region Métier / outils

	sort = (col: string, order: number = 1) => {
		if (!this.sortFlag) return;
		this.sortFlag = false;

		if (order == undefined) order = 1;

		let colDef = this.state.colDefs.filter(c => c.Key == col)[0];
		if (colDef == undefined) return;

		let sortedRows = this.state.rows.sort((a, b) => {
			switch (colDef.DataType) {
				case InternalTypeEnum.Alpha:
				case InternalTypeEnum.Blob:
				case InternalTypeEnum.Clob:
				case InternalTypeEnum.Menu:
				case InternalTypeEnum.Uuid:
					{
						let val1 = a[col];
						let val2 = b[col];
						return (val1 > val2) ? order : -order
					}

				case InternalTypeEnum.Date:
				case InternalTypeEnum.Datetime:
					{
						let val1 = moment(a[col], AppLabels.tabSortDateFormat).toDate();
						let val2 = moment(b[col], AppLabels.tabSortDateFormat).toDate();
						return (val1 > val2) ? order : -order
					}

				case InternalTypeEnum.Decimal:
				case InternalTypeEnum.Double:
				case InternalTypeEnum.Float:
					{
						let val1 = parseFloat(a[col]);
						let val2 = parseFloat(b[col]);
						return (val1 > val2) ? order : -order
					}

				case InternalTypeEnum.Short:
				case InternalTypeEnum.Long:
					{
						let val1 = parseInt(a[col]);
						let val2 = parseInt(b[col]);
						return (val1 > val2) ? order : -order
					}

				default:
					let val1 = a[col];
					let val2 = b[col];
					return (val1 > val2) ? order : -order

			}
		})

		this.setState({ rows: sortedRows });
	}

	//#endregion

	//#region Rendus

	render() {
		let table = this.props.table;
		let rows = this.state.rows;

		if (!table.Visible) return null;
		let inlineStyle = Utils.decodeInlineStyleFromJson(table.InlineStyle);

		return (
			<CModal centered closeOnBackdrop={false} className={"KControlChoice "} show={this.props.isOpen} >
				<CModalBody>
					<CAlert color="info">
						{this.props.table.title + " (" + rows.length + ")"}
					</CAlert>

					<div className={"KControl KControlTable KMultiScan"} style={inlineStyle} >
						<Table size="sm" >
							<thead>
								<tr>
									<th className={"KTableHeaderCol action"}></th>
									{
										this.state.colDefs.filter(c => c.Visible).map((x, i) => {
											if (x.Class == undefined) x.Class = "";
											let sorted = (x.Key == this.state.sortCol) ? (this.state.ascending == 1 ? " sorted_ascending " : " sorted_descending  ") : "";
											return (<th onClick={() => { this.onHeaderClick(x) }} className={"KTableHeaderCol " + x.Class} key={i}><div className="thContent">{x.Title}<div className={sorted}></div></div></th>)
										}
										)
									}
								</tr>
							</thead>
							<tbody>
								{
									rows.map((row, rowIndex) => {

										let isRowSelected = (this.state.selectedIndex == row["_ID_"]);

										return (
											<tr key={rowIndex} className={((isRowSelected == true) ? "selected" : "")} onClick={() => { this.onRowSelected(row, rowIndex) }}>
												<td><CButton className="TabIcon" size="sm" type="submit" role="button" color="danger" name="remorow" onClick={() => { this.onRemoveRowClick(row, rowIndex) }} >✖</CButton></td>
												{
													this.state.colDefs.filter(column => column.Visible).map((column, j) => {
														let css = column.Class;
														if (css == undefined) css = "";
														if (css == "undefined") css = "";

														// && (column.Disable == false)
														if (isRowSelected) {
															// Mode édition de la ligne

															column.Value = row[column.Key];

															switch (column.Type) {
																case ControlTypeEnum.label:
																case ControlTypeEnum.progress:
																case ControlTypeEnum.input:
																	return (
																		<td className={"KTableCol " + css} key={j}>
																			<KInput Control={column} onChange={(e) => { this.onInputChange(e, row, column.Key) }} />
																		</td>
																	)
																case ControlTypeEnum.select:
																case ControlTypeEnum.selectControled:
																case ControlTypeEnum.selectFree:
																	return (
																		<td className={"KTableCol " + css} key={j}><CInput size="sm" onChange={(e) => { this.onInputChange((e.target as HTMLInputElement).value, row, column.Key) }} value={row[column.Key]} inputMode={!this.state.virtualKeyboard ? "none" : "text"} > </CInput></td>
																	)
																case ControlTypeEnum.checkbox:
																	return (
																		<td className={"KTableCol " + css} key={j}><input checked={row[column.Key] == "2" ? true : false} type="checkbox" onClick={(e) => { this.onInputChange((e.target as HTMLInputElement).checked ? "2" : "1", row, column.Key) }} ></input></td>
																	)

																default:
																	return (<td className={"KTableCol " + css} style={inlineStyle} key={j}>{row[column.Key]}</td>)
															}



														}
														else {
															// Mode affichage seul
															// Selon le type de la colonne, on va afficher le bon controle
															switch (column.Type) {
																case ControlTypeEnum.progress:
																	return (<td className={"KTableCol " + css} style={inlineStyle} key={j}><KProgress Value={row[column.Key]} ctrl={column as IProgressParams}  ></KProgress></td>)

																case ControlTypeEnum.checkbox:
																	return (<td className={"KTableCol " + css} style={inlineStyle} key={j}><input disabled type="checkbox" checked={(row[column.Key] as string) == "2" ? true : false}></input></td>)

																default:
																	return (<td className={"KTableCol " + css} style={inlineStyle} key={j}>{row[column.Key]}</td>)
															}
														}

													}
													)
												}
											</tr>
										)
									})
								}
							</tbody>
						</Table>
					</div>

				</CModalBody>
				<CModalFooter>
					<CButton color='success' disabled={!this.state.isValid} onClick={() => this.onCloseClick(true)}>✓ {AppLabels.submit}</CButton>
					<CButton color='danger' onClick={() => this.onCloseClick(false)}>✖ {AppLabels.cancel}</CButton>
				</CModalFooter>
			</CModal>
		);
	}

	//#endregion 
}
